import React, { useState } from 'react';
import ExclamationIcon from '@heroicons/react/outline/ExclamationIcon.js';
import PlusIcon from '@heroicons/react/outline/PlusIcon.js';
import { T } from '@tribeplatform/react-components/i18n';
import { RichTextPickerField } from '@tribeplatform/react-components/PickerField';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { SortableList } from '@tribeplatform/react-ui-kit/SortableList';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { useBlock } from '../../hooks/index.js';
export const AccordionBlockSettings = () => {
    const { block: { props: { items, title }, }, upsertProp, } = useBlock();
    const [activeIndex, setActiveIndex] = useState(0);
    const addItem = () => {
        const newItems = [...items, { title: '', description: '' }];
        const index = newItems.length - 1;
        upsertProp('items', newItems);
        setActiveIndex(index);
    };
    const deleteItem = (items, key, itemIndex) => {
        upsertProp(key, [
            ...items.slice(0, itemIndex),
            ...items.slice(itemIndex + 1),
        ]);
    };
    const editItem = (index, changes) => {
        upsertProp('items', [
            ...items.slice(0, index),
            Object.assign(Object.assign({}, items[index]), changes),
            ...items.slice(index + 1),
        ]);
        setActiveIndex(index);
    };
    const onDragEnd = (items, key) => result => {
        if (!result.destination) {
            return;
        }
        const newItems = SortableList.reorder(items, result.source.index, result.destination.index);
        upsertProp(key, newItems);
    };
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(FormControl.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }), value: title, onChange: e => upsertProp('title', e.target.value) }),
        React.createElement(SortableList, { onDragEnd: onDragEnd(items, 'items'), items: items.map((it, index) => (Object.assign(Object.assign({}, it), { id: index }))), renderItem: (item, index) => (React.createElement(SortableList.Item, { id: item.id }, index === activeIndex ? (React.createElement("div", { className: "space-y-3 bg-surface-subdued p-3 rounded-md" },
                React.createElement("div", { className: "flex items-center space-s-2" },
                    React.createElement(SortableList.Handle, null),
                    React.createElement("span", { className: "truncate" }, item.title || (React.createElement(T, { id: "Blocks.Accordion.DefaultTitle", defaultMessage: "Accordion title" })))),
                React.createElement(FormControl.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }), value: item.title, onChange: e => editItem(index, { title: e.target.value }) }),
                React.createElement(RichTextPickerField, { name: "description", label: React.createElement(T, { id: "Generics.Description", defaultMessage: "Description" }), value: item.description, onChange: value => {
                        editItem(index, { description: value });
                    } }),
                React.createElement(FormControl.Toggle, { name: "defaultOpen", label: React.createElement("div", { className: "flex space-s-1 items-center" },
                        React.createElement("span", null,
                            React.createElement(T, { id: "Blocks.Accordion.DefaultOpenLabel", defaultMessage: "Default open" })),
                        React.createElement(Tooltip, { placement: "top" },
                            React.createElement(Tooltip.Trigger, null,
                                React.createElement(ExclamationIcon, { className: "h-4 w-4" })),
                            React.createElement(Tooltip.Panel, null,
                                React.createElement(T, { id: "Blocks.Accordion.Tooltip", defaultMessage: "You won\u2019t see any changes on the editor for this property" })))), checked: item.defaultOpen, onChange: value => {
                        editItem(index, { defaultOpen: value });
                    } }),
                React.createElement(Button, { variant: "outline", onClick: () => deleteItem(items, 'items', index) },
                    React.createElement(T, { id: "Generics.Remove", defaultMessage: "Remove" })))) : (React.createElement("div", { className: "bg-surface-subdued p-3 rounded-md cursor-pointer", onClick: () => setActiveIndex(index) },
                React.createElement("div", { className: "flex items-center space-s-2" },
                    React.createElement(SortableList.Handle, null),
                    React.createElement("span", { className: "truncate" }, item.title || (React.createElement(T, { id: "Blocks.Accordion.DefaultTitle", defaultMessage: "Accordion title" })))))))) }),
        React.createElement(Button, { variant: "outline", onClick: () => addItem(), fullWidth: true, leadingIcon: React.createElement(PlusIcon, null) },
            React.createElement(T, { id: "Blocks.Accordion.AddButtonText", defaultMessage: "Add accordion" }))));
};
//# sourceMappingURL=Settings.js.map